export const OFFER_ERROR_MESSAGES = {
  // Offer Name
  OFFER_NAME_REQUIRED: 'To pole jest wymagane',
  OFFER_NAME_MAX_LENGTH: 'Nazwa oferty nie może przekraczać 200 znaków',
  OFFER_NAME_EXISTS: 'Taka nazwa oferty już istnieje',

  // Subscription Plans
  INVALID_SUBSCRIPTION_PLAN_ID: 'Nieprawidłowy identyfikator planu subskrypcji',

  // Discount Value
  DISCOUNT_VALUE_MIN: 'Wartość rabatu nie może być mniejsza niż 0%',
  DISCOUNT_VALUE_MAX: 'Wartość rabatu nie może przekraczać 100%',
  DISCOUNT_VALUE_DECIMAL:
    'Wartość rabatu może mieć maksymalnie 2 miejsca po przecinku',
  DISCOUNT_VALUE_REQUIRED: 'To pole jest wymagane',

  // Validity Period (Dates)
  INVALID_START_DATE_FORMAT: 'Nieprawidłowy format daty rozpoczęcia',
  INVALID_END_DATE_FORMAT: 'Nieprawidłowy format daty zakończenia',
  START_DATE_PAST: 'Data rozpoczęcia nie może być w przeszłości',
  END_DATE_PAST: 'Data zakończenia nie może być w przeszłości',
  END_DATE_BEFORE_START:
    'Data zakończenia musi być późniejsza niż data rozpoczęcia',
  DATE_REQUIRED: 'To pole jest wymagane',

  // API errors
  UNAUTHORIZED: 'Brak autoryzacji',
  VALIDATION_ERROR: 'Nieprawidłowy format JSON w treści żądania',
  INTERNAL_SERVER_ERROR: 'Wewnętrzny błąd serwera',
  DEFAULT_ERROR: 'Wystąpił błąd podczas tworzenia oferty',
  NETWORK_ERROR: 'Coś poszło nie tak. Spróbuj ponownie.',
  UNEXPECTED_ERROR: 'Wystąpił nieoczekiwany błąd. Spróbuj ponownie.',
  NO_PERMISSION_TOOLTIP: 'Nie masz uprawnień do wykonania tej akcji',
} as const;
